module.exports = __webpack_public_path__ + "static/img/icon1.571259be.png";